import React from 'react';
import { clsx } from 'clsx';

export type BadgeVariant = 'accent' | 'ok' | 'warn' | 'err' | 'neutral';
export type BadgeSize = 'sm' | 'md';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
}

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  accent: 'bg-accent-soft text-accent-ink',
  ok: 'bg-ok-soft text-ok',
  warn: 'bg-warn-soft text-warn',
  err: 'bg-err-soft text-err',
  neutral: 'bg-surface-muted text-text-soft',
};

const SIZE_CLASSES: Record<BadgeSize, string> = {
  sm: 'px-1.5 py-0 text-[10px]',
  md: 'px-2 py-0.5 text-xs',
};

export const Badge: React.FC<BadgeProps> = ({ variant = 'neutral', size = 'md', className, children, ...rest }) => (
  <span
    className={clsx(
      'inline-flex items-center gap-1 font-medium rounded-full',
      VARIANT_CLASSES[variant],
      SIZE_CLASSES[size],
      className,
    )}
    {...rest}
  >
    {children}
  </span>
);
